import { DateTime } from "luxon";

const getClosestNextDayByWeekDay = (startDate: Date, weekDayIndex: number) => {
  const currentWeekDay = startDate.getDay();
  const res = new Date(startDate.getTime());

  const weekIndexDiff = Math.abs(weekDayIndex - currentWeekDay);
  const daysToAdd = weekIndexDiff === 0 ? 7 : weekIndexDiff;
  res.setDate(res.getDate() + daysToAdd);

  return res;
};

const dateFromUtcMinutes = (originalDate: Date | number, minutes: number) => {
  // let date: Date;
  // if (originalDate instanceof Date) {
  //   date = new Date(originalDate.getTime());
  // } else {
  //   if (typeof originalDate === "number" && !Number.isNaN(originalDate)) {
  //     date = new Date(originalDate);
  //   } else {
  //     date = new Date();
  //   }
  // }
  // const utcHours = Math.floor(minutes / 60);
  // const remainingMinutes = minutes - utcHours * 60;
  // date.setUTCHours(utcHours, remainingMinutes, 0, 0);
  let date: Date;
  if (originalDate instanceof Date) {
    date = DateTime.fromJSDate(originalDate)
      .toUTC()
      .set({
        hour: 0,
        minute: 0,
        second: 0,
      })
      .plus({
        minutes,
      })
      .setZone("Europe/Rome")
      .toJSDate();
  } else {
    date = DateTime.fromJSDate(new Date(originalDate))
      .toUTC()
      .set({
        hour: 0,
        minute: 0,
        second: 0,
      })
      .plus({
        minutes,
      })
      .setZone("Europe/Rome")
      .toJSDate();
  }

  return date;
};

const utcMinutesFromDate = (
  date: Date | undefined | null
): number | undefined => {
  if (date) {
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const totalMinutes = hours * 60 + minutes;

    return totalMinutes;
  }
  return void 0;
};

const ignoreDateDST = (originalDate: Date): Date => {
  let d = DateTime.fromJSDate(originalDate);
  if (d.isInDST) {
    d = d.plus({
      hour: -1,
    });
  }

  return d.toJSDate();
};

const timeRangeToString = (
  date: Date,
  fromMinutes: number,
  toMinutes: number
): string => {
  const from = dateFromUtcMinutes(date, fromMinutes);
  const to = dateFromUtcMinutes(date, toMinutes);

  return [from.toLocaleTimeString(), to.toLocaleTimeString()].join("-");
};

/**
 * Returns whether two dates shares the same day, month and year.
 *
 * @export
 * @param {Date} dateInstance
 * @param {Date} otherDateInstance
 * @returns {boolean}
 */
const isSameDate = (dateInstance: Date, otherDateInstance: Date) => {
  return (
    dateInstance.getUTCFullYear() === otherDateInstance.getUTCFullYear() &&
    dateInstance.getUTCMonth() === otherDateInstance.getUTCMonth() &&
    dateInstance.getUTCDate() === otherDateInstance.getUTCDate()
  );
};

export {
  dateFromUtcMinutes,
  getClosestNextDayByWeekDay,
  timeRangeToString,
  utcMinutesFromDate,
  isSameDate,
  ignoreDateDST,
};
